module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_v-container",
    attrs: {
      "id": _vm.containerId
    },
    on: {
      "touchstart": function($event) {
        _vm.touchStart($event)
      },
      "touchmove": function($event) {
        _vm.touchMove($event)
      },
      "touchend": function($event) {
        _vm.touchEnd($event)
      },
      "mousedown": function($event) {
        _vm.mouseDown($event)
      },
      "mousemove": function($event) {
        _vm.mouseMove($event)
      },
      "mouseup": function($event) {
        _vm.mouseUp($event)
      }
    }
  }, [_c('div', {
    staticClass: "_v-content",
    attrs: {
      "id": _vm.contentId
    }
  }, [(_vm.onRefresh) ? _c('div', {
    staticClass: "pull-to-refresh-layer",
    class: {
      'active': _vm.state == 1, 'active refreshing': _vm.state == 2
    }
  }, [_c('span', {
    staticClass: "spinner-holder"
  }, [(_vm.state != 2) ? _c('arrow', {
    staticClass: "arrow",
    attrs: {
      "fillColor": _vm.refreshLayerColor
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state != 2) ? _c('span', {
    staticClass: "text",
    style: ({
      color: _vm.refreshLayerColor
    }),
    domProps: {
      "textContent": _vm._s(_vm.refreshText)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 2) ? _c('span', [_vm._t("refresh-spinner", [_c('spinner', {
    style: ({
      fill: _vm.refreshLayerColor,
      stroke: _vm.refreshLayerColor
    })
  })])], 2) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.onInfinite) ? _c('div', {
    staticClass: "loading-layer"
  }, [_c('span', {
    staticClass: "spinner-holder",
    class: {
      'active': _vm.showLoading
    }
  }, [_vm._t("infinite-spinner", [_c('spinner', {
    style: ({
      fill: _vm.loadingLayerColor,
      stroke: _vm.loadingLayerColor
    })
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "no-data-text",
    class: {
      'active': !_vm.showLoading && _vm.loadingState == 2
    },
    style: ({
      color: _vm.loadingLayerColor
    }),
    domProps: {
      "textContent": _vm._s(_vm.noDataText)
    }
  })]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3dbfe2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scroller.vue
// module id = 13
// module chunks = 0